export const LEARN_MORE_LINK = 'https://help.playbookux.com/en/articles/10629685-bring-your-own-participants-information-collection';
